import React from 'react';
import { Form } from 'antd';
import { FormField } from '../../../../SmartDataTable/types';
import { FormFieldRenderer, getValidationRules } from '../FormFieldRenderer';

interface FormItemRendererProps {
  field: FormField;
  form?: any;
}

export const FormItemRenderer: React.FC<FormItemRendererProps> = ({
  field,
  form,
}) => {
  // Get validation rules from FormFieldRenderer
  const rules = getValidationRules(field);

  // Use array syntax for nested names
  const name = field.name.includes('.') ? field.name.split('.') : field.name;

  // Special handling for markdown and file fields
  let valuePropName, getValueFromEvent;
  if (field.type === 'markdown') {
    valuePropName = 'value';
    getValueFromEvent = (value: any) => value;
  }
  if (field.type === 'file') {
    valuePropName = 'fileList';
    getValueFromEvent = (e: any) => (Array.isArray(e) ? e : e && e.fileList);
  }

  // For custom fields that are display-only (like reference details), don't wrap in Form.Item
  if (field.type === 'custom' && field.render && !field.required) {
    // If the field has dependencies, use shouldUpdate to re-render when dependencies change
    if (field.dependencies && field.dependencies.length > 0) {
      return (
        <Form.Item
          key={field.name}
          shouldUpdate={(prevValues, currentValues) => {
            // Check if any dependency has changed
            return field.dependencies!.some((dep: string) => 
              prevValues[dep] !== currentValues[dep]
            );
          }}
          noStyle
        >
          {() => (
            <div style={{ marginBottom: field.label ? 16 : 0 }}>
              {field.label && (
                <div style={{ marginBottom: 8, fontWeight: 500, color: '#262626' }}>
                  {field.label}
                </div>
              )}
              <FormFieldRenderer field={field} form={form} />
            </div>
          )}
        </Form.Item>
      );
    }

    return (
      <div key={field.name} style={{ marginBottom: field.label ? 16 : 0 }}>
        {field.label && (
          <div style={{ marginBottom: 8, fontWeight: 500, color: '#262626' }}>
            {field.label}
          </div>
        )}
        <FormFieldRenderer field={field} form={form} />
      </div>
    );
  }

  return (
    <Form.Item
      key={field.name}
      name={name}
      label={field.label}
      rules={rules}
      tooltip={field.tooltip}
      hidden={field.hidden}
      validateTrigger={['onBlur', 'onSubmit']}
      {...(valuePropName ? { valuePropName } : {})}
      {...(getValueFromEvent ? { getValueFromEvent } : {})}
    >
      <FormFieldRenderer field={field} form={form} />
    </Form.Item>
  );
};
